/**
 * コンテンツの高さ変化を親ウィンドウにpostMessageで通知する
 */

const isAllowedOrigin = (origin) => {
  if (!origin) return false;
  if (origin === 'https://preview.studio.site') return true;
  if (origin === 'https://app.studio.design') return true;
  if (origin === 'https://friendcampaign.studio.site') return true;
  if (origin === 'https://anymarry.mwed.jp') return true;
  return false;
};

let parentViewportHeight = null;
let verifiedParentOrigin = '*';

const getParentViewportHeightFallback = () => {
  try {
    if (window.parent && window.parent !== window) {
      const h = Number(window.parent.innerHeight);
      if (Number.isFinite(h) && h > 0) return h;
    }
  } catch (e) {
    // クロスオリジン時はアクセス不可のためフォールバックへ
  }

  const screenHeight = Number(window.screen?.height);
  if (Number.isFinite(screenHeight) && screenHeight > 0) return screenHeight;

  return null;
};

// header の box-shadow: 0 0 8px が iframe 下端でクリップされないよう余白を加える。
// クロスオリジン（STUDIO等）では親が直接 DOM を読めないため、
// postMessage で送る高さに必ず加算する必要がある。
const SHADOW_MARGIN = 20;

const sendHeight = () => {
  const header = document.querySelector('.js-global-header');
  const planItems = document.querySelector('.js-global-header-plan-items');
  const overlay = document.querySelector('.js-global-header-overlay');

  const headerRect = header ? header.getBoundingClientRect() : null;

  const isMenuOpen = !!(
    header?.classList.contains('-active') &&
    planItems?.classList.contains('is-visible') &&
    overlay?.classList.contains('is-visible')
  );

  if (isMenuOpen) {
    const viewportHeight =
      parentViewportHeight ||
      getParentViewportHeightFallback() ||
      window.visualViewport?.height ||
      window.innerHeight;
    const height = Math.ceil(viewportHeight);
    window.parent.postMessage({ type: 'embed-resize', height }, verifiedParentOrigin);
    return;
  }

  // 通常時: 実描画下端 + box-shadow 分の余白を加算
  let height = 88 + SHADOW_MARGIN;

  if (headerRect) {
    const bottom = Math.ceil(headerRect.bottom);
    if (bottom > 0) {
      height = Math.max(height, bottom + SHADOW_MARGIN);
    }
  }

  if (planItems?.classList.contains('is-visible')) {
    const rect = planItems.getBoundingClientRect();
    height = Math.max(height, Math.ceil(rect.bottom) + SHADOW_MARGIN);
  }

  if (overlay?.classList.contains('is-visible')) {
    const rect = overlay.getBoundingClientRect();
    height = Math.max(height, Math.ceil(rect.bottom) + SHADOW_MARGIN);
  }

  window.parent.postMessage({ type: 'embed-resize', height }, verifiedParentOrigin);
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.self === window.top) return;

  window.addEventListener('message', (event) => {
    if (!isAllowedOrigin(event.origin)) return;
    if (!event.data || typeof event.data.type !== 'string') return;

    verifiedParentOrigin = event.origin;

    if (event.data.type === 'embed-parent-viewport') {
      const nextHeight = Number(event.data.height);
      if (!Number.isFinite(nextHeight) || nextHeight <= 0) return;
      parentViewportHeight = nextHeight;
      sendHeight();
      return;
    }

    if (event.data.type === 'embed-scroll-state') {
      const header = document.querySelector('.js-global-header');
      if (!header) return;
      if (header.classList.contains('-active')) return;
      if (event.data.hidden) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
    }
  });

  window.parent.postMessage({ type: 'embed-request-parent-viewport' }, verifiedParentOrigin);

  // 初期高さを送信
  sendHeight();

  window.addEventListener('load', sendHeight);

  // ページ全体のリサイズ検知（ResizeObserver）
  const header = document.querySelector('.js-global-header');
  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => {
      sendHeight();
    });
    ro.observe(document.documentElement);
    if (header) {
      ro.observe(header);
    }
  }

  // ハンバーガーメニュー開閉など、クラス変化による高さ変化を検知
  // （ResizeObserver だけでは body固定時に取れないケースの補完）
  if (header) {
    const mo = new MutationObserver(() => {
      // レイアウト更新後に高さを取得するため requestAnimationFrame を挟む
      requestAnimationFrame(() => {
        requestAnimationFrame(sendHeight);
      });
    });
    mo.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  // plan-items の is-visible 変化も監視（PCドロップダウン対応）
  const planItems = document.querySelector('.js-global-header-plan-items');
  if (planItems) {
    const mo = new MutationObserver(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(sendHeight);
      });
    });
    mo.observe(planItems, { attributes: true, attributeFilter: ['class'] });
  }
});
